import { useContext, useMemo } from 'react';
import { useLocation } from 'react-router';

import { FunnelContext, UserContext } from 'components/signUpFunnel/Contexts';

const useFunnelNavigation = () => {
  const { funnel } = useContext(FunnelContext);
  const { user } = useContext(UserContext);
  const { pathname } = useLocation();

  const currentStep = useMemo(
    () => funnel?.find(step => step.route === pathname) || null,
    [funnel, pathname]
  );

  const nextStep = useMemo(
    () => funnel?.find(step => step.route === currentStep?.nextStep) || null,
    [funnel, currentStep]
  );

  const previousStep = useMemo(
    () => funnel?.find(step => step.route === currentStep?.previousStep) || null,
    [funnel, currentStep]
  );

  const userStep = useMemo(
    () => funnel?.find(step => step.status === user?.status) || null,
    [funnel, user?.status]
  );

  const userRoute = useMemo(
    () => funnel?.find(step => step.status === user?.status)?.route || null,
    [funnel, user?.status]
  );

  const locationPercentage = useMemo(() => {
    if (!currentStep) return null;

    return currentStep.locationPercentage ?? currentStep.location_percentage ?? null;
  }, [currentStep]);

  return {
    currentStep,
    nextStep,
    previousStep,
    userStep,
    userRoute,
    locationPercentage,
  };
};

export default useFunnelNavigation;
